<template>
  <el-card class="h-full relative flex flex-col">
    <div class="h-full flex flex-col">
      <div class="flex mb-10px mr-10px flex-wrap">
        <el-input
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请输入隐患描述"
          v-model="searchData.keywords"
          clearable
        ></el-input>
        <el-select
          v-model="searchData.hiddenDangerSource"
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择隐患来源"
          clearable
        >
          <el-option
            v-for="item in hiddenSourceList"
            :key="item.value"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <el-select
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择区域"
          v-model="searchData.areaId"
          clearable
        >
          <el-option
            v-for="item in areaList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          v-model="searchData.hiddenDangerlevel"
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择隐患等级"
          clearable
        >
          <el-option
            v-for="item in hiddenLevelList"
            :key="item.value"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <div class="mb-10px">
          <department-select
            class="mr-10px !w-50"
            placeholder="请选择上报人所属部门"
            v-model="searchData.reporterDepartmentId"
          ></department-select>
        </div>
        <div class="mb-10px">
          <department-select
            class="mr-10px !w-50"
            placeholder="请选择核实所属部门"
            v-model="searchData.hiddenDangerVerifierPersonDepartmentId"
          ></department-select>
        </div>
        <div class="mb-10px">
          <department-select
            class="mr-10px !w-50"
            placeholder="请选择整改所属部门"
            v-model="searchData.personChargeHiddenDangerRectificationDepartmentId"
          ></department-select>
        </div>
        <div class="mb-10px">
          <department-select
            class="mr-10px !w-50"
            placeholder="请选择验收部门"
            v-model="searchData.personChargeHiddenDangerAcceptanceDepartmentId"
          ></department-select>
        </div>
        <el-date-picker
          class="mr-10px mb-10px"
          v-model="datePickerValue"
          format="yyyy-MM-dd"
          size="small"
          type="daterange"
          :clearable="true"
          start-placeholder="验收开始时间"
          end-placeholder="验收结束时间"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-date-picker
          class="mr-10px mb-10px"
          v-model="reportTime"
          format="yyyy-MM-dd"
          size="small"
          type="daterange"
          :clearable="true"
          start-placeholder="上报开始时间"
          end-placeholder="上报结束时间"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <!-- <el-select
          v-model="searchData.ownedSystemOrUnit"
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择所属系统/机组"
          clearable
        >
          <el-option
            v-for="item in ownedSystemOrUnitList"
            :key="item.id"
            :label="item.displayName"
            :value="item.id"
          ></el-option>
        </el-select> -->
        <el-select
          v-model="searchData.hiddenDangerLedgerStatus"
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请选择隐患状态"
          clearable
        >
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请输入安全检查标题"
          v-model="searchData.safetyInspectionTitle"
          clearable
        ></el-input>
        <el-input
          size="small"
          class="mr-10px !w-50 mb-10px"
          placeholder="请输入安全检查期数"
          v-model="searchData.safetyInspectionPeriods"
          clearable
        ></el-input>
        <el-checkbox v-model="searchData.overdueNotCompleted" class="mr-10px mt-10px"
          >逾期未完成</el-checkbox
        >
        <el-checkbox v-model="searchData.sevenDayExpirationWarning" class="mr-10px mt-10px"
          >7天内到期预警</el-checkbox
        >
        <el-checkbox v-model="searchData.completed" class="mr-10px mt-10px">已完成</el-checkbox>
        <el-checkbox v-model="searchData.unexpired" class="!mr-10px mt-10px">未到期</el-checkbox>
        <el-checkbox v-model="searchData.isSafe" class="!mr-10px mt-10px">是否属于安全检查</el-checkbox>
        <el-date-picker
          class="mr-10px h-36px"
          v-model="searchData.rectificationPeriod"
          format="yyyy-MM"
          size="small"
          type="month"
          :clearable="true"
          placeholder="整改期限"
          value-format="yyyy-MM"
        >
        </el-date-picker>
        <person-select
          v-model="searchData.personChargeHiddenDangerAcceptanceId"
          placeholder="请选择验收人"
          class="mb-10px mr-10px"
        ></person-select>
        <el-button class="mb-10px" size="small" type="primary" @click="searchList">搜索</el-button>
        <el-button class="mb-10px" size="small" @click="resetSearch">重置</el-button>
        <el-button
          class="mb-10px"
          size="small"
          @click="handleEvent(null, 'export', false)"
          :disabled="!$hasAccess('export')"
        >
          批量导出
        </el-button>
        <el-button
          class="mb-10px"
          size="small"
          @click="handleEvent(null, 'export', true)"
          :disabled="!$hasAccess('export')"
        >
          带图批量导出
        </el-button>
        <el-button
          class="mb-10px"
          size="small"
          @click="handleEvent(null, 'batchImport')"
          :disabled="!$hasAccess('batchImport')"
          >批量导入</el-button
        >
      </div>
      <div class="flex-auto h-0px">
        <el-table
          ref="table"
          :data="tableData"
          border
          class="w-full"
          :height="tableHeight"
          stripe
          v-loading="loading"
          @selection-change="handleSelection"
          row-key="id"
        >
          <el-table-column
            type="selection"
            width="50"
            :reserve-selection="true"
            row-key="id"
          ></el-table-column>
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column
            label="隐患描述"
            prop="hiddenDangerName"
            min-width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="所在区域"
            prop="areaStr"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="隐患来源"
            prop="hiddenDangerSourceStr"
            min-width="80"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column
            label="所属机组/系统"
            prop="ownedSystemOrUnitText"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column> -->
          <el-table-column
            label="隐患等级"
            prop="hiddenDangerlevelStr"
            min-width="80"
            show-overflow-tooltip
          ></el-table-column>

          <el-table-column
            label="状态"
            prop="hiddenDangerLedgerStatusStr"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column
            label="隐患类型"
            prop="hiddenDangerTypeStr"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column> -->
          <el-table-column
            label="安全检查标题"
            prop="safetyInspectionTitle"
            min-width="160"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="安全检查期数"
            prop="safetyInspectionPeriods"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="隐患上报人"
            prop="reporterName"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="上报人所属部门"
            prop="reporterDepartment"
            min-width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="上报时间" prop="reportTime" show-overflow-tooltip width="180px">
            <template slot-scope="scope">
              {{
                scope.row.reportTime
                  ? dayjs(scope.row.reportTime).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="隐患审核人"
            prop="hiddenDangerVerifierPersonName"
            min-width="120"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="隐患审核人所属部门"
            prop="hiddenDangerVerifierPersonDepartment"
            min-width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="隐患整改期限"
            prop="hazardVerificationTime"
            show-overflow-tooltip
            width="180px"
          >
            <template slot-scope="scope">
              {{
                scope.row.hazardVerificationTime
                  ? dayjs(scope.row.hazardVerificationTime).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="隐患整改负责人"
            prop="personChargeHiddenDangerRectificationName"
            min-width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="整改所属部门"
            prop="personChargeHiddenDangerRectificationDepartment"
            min-width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="整改完成时间"
            prop="startRectificationCompletionTime"
            show-overflow-tooltip
            width="180px"
          >
            <template slot-scope="scope">
              {{
                scope.row.startRectificationCompletionTime
                  ? dayjs(scope.row.startRectificationCompletionTime).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              }}
            </template>
          </el-table-column>

          <el-table-column
            label="隐患验收人"
            prop="personChargeHiddenDangerAcceptanceName"
            min-width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="验收所属部门"
            prop="personChargeHiddenDangerAcceptanceDepartment"
            min-width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="验收时间"
            prop="acceptanceTime"
            show-overflow-tooltip
            width="180px"
          >
            <template slot-scope="scope">
              {{
                scope.row.acceptanceTime
                  ? dayjs(scope.row.acceptanceTime).format('YYYY-MM-DD HH:mm:ss')
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="200">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click.native="handleEvent(scope.row, 'read')"
                :disabled="!$hasAccess('read')"
                >查看</el-button
              >
              <!-- <el-button
                size="mini"
                @click.native="handleEvent(scope.row, 'cancel')"
                :disabled="!($hasAccess('cancel') && scope.row.hiddenDangerLedgerStatus === 12)"
                >销号</el-button
              > -->
              <el-button
                size="mini"
                @click.native="handleEvent(scope.row, 'delete')"
                :disabled="
                  !$hasAccess('delete') ||
                    scope.row.reporterId !== currentUser.Id ||
                    (scope.row.reportStatus !== 2 && scope.row.reportStatus !== 0)
                "
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="searchList"
          @current-change="findList"
          :current-page.sync="pageNo"
          :page-size.sync="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :total="total"
          class="float-right mt-20px ml-10px"
        ></el-pagination>
      </div>
    </div>

    <HiddenBookForm
      v-if="formDialog"
      :formProps="formProps"
      :FormData="FormData"
      @refreshList="findList()"
      @cancel="formDialog = false"
    />
    <CancelDialog
      v-if="cancelDialog"
      @handleOk="handleOk"
      @cancel="cancelDialog = false"
    ></CancelDialog>
    <wiz-upload-file
      v-dialogDrag
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
      @exportResults="exportResults"
    ></wiz-upload-file>
  </el-card>
</template>

<script>
import { HiddenDangerRectificationChecklistApi } from '@wiz-api/double-prevention-management'
import dayjs from 'dayjs'
import { AreaApi } from '@wiz-api/area-management'
import { wizUploadFile } from '@wiz-core/compts'
import { FileApi } from '@wiz-api/file-management'
import qs from 'qs'
import utils from '@/components/safety/enumField/utils'
import DepartmentSelect from '@/components/safety/DepartmentSelect/DepartmentSelect'
import DownResultFile from '@/assets/js/safety/DownResultFile'
import PersonSelect from '@/components/safety/FormSelect/PersonSelect'
import HiddenBookForm from '../../components/HiddenBook/HiddenBookForm'
import CancelDialog from '../../components/HiddenBook/CancelDialog'

const fileApi = new FileApi()

const areaApi = new AreaApi()

const hiddenDangerRectificationChecklistApi = new HiddenDangerRectificationChecklistApi()

export default {
  name: 'hidden-book',
  mixins: [DownResultFile],
  components: {
    HiddenBookForm,
    CancelDialog,
    DepartmentSelect,
    wizUploadFile,
    PersonSelect,
  },
  data() {
    return {
      cancelDialog: false,
      areaList: [],
      hiddenCategoryList: [],
      hiddenTypeList: [],
      hiddenLevelList: [],
      hiddenSourceList: [],
      ownedSystemOrUnitList: [],
      statusList: [
        { label: '待提交', value: 0 },
        // { label: '已提交', value: 1 },
        { label: '被驳回(驳回至上报)', value: 2 },
        { label: '待核实', value: 3 },
        // { label: '已核实', value: 4 },
        { label: '被驳回(驳回至核实)', value: 5 },
        // { label: '待整改', value: 6 },
        { label: '整改中', value: 7 },
        { label: '已整改', value: 8 },
        { label: '超期未整改', value: 9 },
        { label: '延期审核中', value: 10 },
        { label: '待验收', value: 11 },
        { label: '已验收', value: 12 },
        // { label: '已销号', value: 14 },
        { label: '超期整改', value: 15 },
      ],

      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 0, // 目前状态页面0为下载模板 1为上传模板 2为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['zip'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },

      FormData: {},
      formDialog: false,
      detailDialog: false,
      datePickerValue: [],
      reportTime: [], // 上报时间
      id: '',
      formProps: {
        title: '新增隐患排查计划',
        visible: false,
        // create 新增 update 编辑 read 详情
        editType: 'create',
      },
      // 作业活动清单
      tableData: [],
      loading: false,
      searchData: {
        type: '',
        readStatus: '',
        title: '',
        safetyInspectionTitle: '',
        safetyInspectionPeriods: '',
        overdueNotCompleted: null, // 逾期未完成
        sevenDayExpirationWarning: null, // 7天内到期预警
        completed: null, // 已完成
        unexpired: null, // 未到期
        rectificationPeriod: null, // 整改期限
        personChargeHiddenDangerAcceptanceId: null, // 验收人
        reportTimeStart: null, // 上报开始时间
        reportTimeFinish: null, // 上报结束时间
        isSafe: null, // 是否属于安全检查
      },
      total: 0,
      pageNo: 1,
      pageSize: 15,
      selectionData: [],
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    },
    currentUser() {
      return localStorage.getItem('CurrentUser')
        ? JSON.parse(localStorage.getItem('CurrentUser'))
        : {}
    },
  },
  created() {
    this.getSearchQuery()
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.HiddenSource',
        'DoublePreventionManagement.DataCategory.HiddenLevel',
        'DoublePreventionManagement.DataCategory.HiddenType',
        'DoublePreventionManagement.DataCategory.HiddenCategory',
        'DoublePreventionManagement.DataCategory.OwnedSystemOrUnit',
      ],
      [
        'hiddenSourceList',
        'hiddenLevelList',
        'hiddenTypeList',
        'hiddenCategoryList',
        'ownedSystemOrUnitList',
      ],
      this
    )
    this.searchList()
    this.getAreaList()
  },
  watch: {
    datePickerValue(list) {
      if (list && list.length) {
        this.searchData.acceptanceTimeStart = dayjs(list[0]).format('YYYY-MM-DD HH:mm:ss')
        this.searchData.acceptanceTimeEnd = dayjs(list[1]).format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.searchData.acceptanceTimeStart = ''
        this.searchData.acceptanceTimeEnd = ''
      }
    },
    reportTime(list) {
      if (list && list.length) {
        this.searchData.reportTimeStart = dayjs(list[0]).format('YYYY-MM-DD HH:mm:ss')
        this.searchData.reportTimeFinish = dayjs(list[1]).format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.searchData.reportTimeStart = null
        this.searchData.reportTimeFinish = null
      }
    },
  },
  methods: {
    /**
     * @description 提取路由中的查询条件参数
     */
    getSearchQuery() {
      this.searchData = this.$options.data().searchData
      const query = this.$route.query

      this.searchData = {
        ...this.searchData,
        ...query,
        overdueNotCompleted: query.overdueNotCompleted === 'true' ? true : null,
        sevenDayExpirationWarning: query.sevenDayExpirationWarning === 'true' ? true : null,
        completed: query.completed === 'true' ? true : null,
        unexpired: query.unexpired === 'true' ? true : null,
        isSafe: query.isSafe === 'true' ? true : null,
      }
      if (this.searchData.hiddenDangerLedgerStatus) {
        this.searchData.hiddenDangerLedgerStatus = Number(this.searchData.hiddenDangerLedgerStatus)
      }

      if (query.reportTimeStart && query.reportTimeFinish) {
        this.reportTime = [query.reportTimeStart, query.reportTimeFinish]
      }
    },

    async handleOk(remark) {
      // 销号
      const [err, res] = await hiddenDangerRectificationChecklistApi.hiddenDangersLogout({
        body: {
          id: this.FormData.id,
          remark,
        },
      })
      if (!err) {
        this.$message({
          showClose: true,
          message: '销号成功',
          type: 'success',
        })
        this.findList()
      }
      this.cancelDialog = false
    },
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    resetSearch() {
      this.searchData = this.$options.data()
      this.datePickerValue = []
      this.searchList()
    },
    async findList() {
      this.loading = true
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        ...searchData,
        overdueNotCompleted: searchData.overdueNotCompleted || null,
        sevenDayExpirationWarning: searchData.sevenDayExpirationWarning || null,
        completed: searchData.completed || null,
        unexpired: searchData.unexpired || null,
        isSafe: searchData.isSafe || null,
      }
      // 低代码
      if (window.__POWERED_BY_QIANKUN__) {
        const instance = axios.create()
        instance.defaults.baseURL = Wiz.globalSettings.api.endpoints.default
        const token = localStorage.getItem('authorization')
        instance.defaults.headers.common.Authorization = `Bearer ${token}`
        const res1 = await instance.get(
          `/api/double-prevention-management/hidden-danger-rectification-checklists/paged-ledger-list-query?${qs.stringify(
            data
          )}`
        )
        if (res1.status === 200 && res1.data) {
          this.tableData = res1.data.items
          this.total = res1.data.totalCount
          this.loading = false
        }
        return
      }
      const [
        err,
        res,
      ] = await hiddenDangerRectificationChecklistApi.hiddenDangerLedgerPagedListQuery(data)
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
        this.loading = false
      }
    },
    refreshList() {
      this.findList()
    },
    // 选中
    handleSelection(values) {
      this.selectionData = values.map((item) => {
        return item.id
      })
    },
    // 列表操作-事件
    handleEvent(row = null, operation, type = false) {
      switch (operation) {
        case 'delete':
          this.$confirm('请确认是否删除计划？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              const [err, res] = await hiddenDangerRectificationChecklistApi.callDelete(row.id)
              if (!err) {
                this.$message.success('删除成功')
                this.findList()
              }
            })
            .catch(() => {})
          break
        case 'cancel':
          this.FormData = row
          this.cancelDialog = true
          break
        case 'create':
          this.initDialog(row, operation)
          break
        case 'read':
          this.initDialog(row, operation)
          break
        case 'update':
          this.initDialog(row, operation)
          break
        case 'completionStatus':
          this.initDialog(row, operation)
          break
        case 'publish':
          this.$confirm('请确认是否发布该计划？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              const [err, res] = await hiddenDangerRectificationChecklistApi.publishPlan({
                palanId: row.id,
              })
              if (!err) {
                this.$message.success('发布成功')
                this.findList()
              }
            })
            .catch(() => {})
          break
        case 'batchImport':
          this.uploadFileProps.active = 0
          this.uploadFileProps.visible = true
          break
        case 'export':
          // if (!this.selectionData || this.selectionData.length === 0) {
          //   this.$message({
          //     showClose: true,
          //     message: '请勾选要导出的记录',
          //     type: 'warning',
          //   })
          //   return
          // }
          this.export(type)
          break
        default:
          break
      }
    },
    async exportResults() {
      const [err, res] = await fileApi.download(this.uploadFileProps.resultFile, {
        returnType: 'Blob',
      })
      if (!err) {
        this.downLoadExcel('导入结果', res, 'excel')
      }
    },
    // 下载模板
    async exportTemplate() {
      const [
        err,
        res,
      ] = await hiddenDangerRectificationChecklistApi.hiddenDangerLedgerExcelTemplateFile({
        returnType: 'Blob',
      })
      if (!err) {
        this.downLoadExcel('隐患台账模板', res, 'zip')
        this.$message({
          showClose: true,
          message: '模板下载成功',
          type: 'success',
        })
      }
    },
    // 上传文件
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append('input', value)
      })
      const [err, res] = await hiddenDangerRectificationChecklistApi.hiddenDangerLedgerExcelFile({
        input: formData.get('input'),
      })
      if (!err) {
        if (res.code === 1) {
          this.uploadFileProps.successCount = res.data?.numberSuccesses
          this.uploadFileProps.failureCount = res.data?.numberFailures
          // 如需兼容老样式，则resultFile字段为空或者不设置皆可
          this.uploadFileProps.resultFile = res.data?.fileId
          this.uploadFileProps.active = 2
          this.resetSearch()
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          })
        }
      }
      this.uploadFileProps.btnLoading = false
    },
    async export(type) {
      const searchData = utils.deleteFormField(this.searchData)
      const [
        err,
        res,
      ] = await hiddenDangerRectificationChecklistApi.hiddenDangersLedgerExportToExcelFile({
        body: {
          HiddenDangersIds: this.selectionData,
          returnType: 'Blob',
          exportImg: type,
          ...searchData,
          overdueNotCompleted: searchData.overdueNotCompleted || null,
          sevenDayExpirationWarning: searchData.sevenDayExpirationWarning || null,
          completed: searchData.completed || null,
          unexpired: searchData.unexpired || null,
        },
      })
      if (!err) {
        this.downLoadExcel('隐患台账数据', res, 'excel')
        this.$message({
          showClose: true,
          message: '导出成功',
          type: 'success',
        })
      }
    },
    // 文件流下载
    downLoadExcel(fileName = '下载文件', data, type) {
      const fileType = {
        zip: 'application/zip',
        excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }
      const blob = new Blob([data], {
        type: fileType[type],
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${fileName}`
      link.click()
      window.URL.revokeObjectURL(link.href)
    },
    async initDialog(row, operation) {
      // 没有新增获取数据
      this.formProps.editType = operation
      this.formProps.title = `${
        // eslint-disable-next-line no-nested-ternary
        operation === 'create' ? '新增' : operation === 'update' ? '编辑' : '查看'
      }隐患信息`
      if (operation === 'create') {
        this.FormData = this.$options.data().FormData
      } else {
        let resVal = {}
        if (window.__POWERED_BY_QIANKUN__) {
          // 低代码
          const instance = axios.create()
          instance.defaults.baseURL = Wiz.globalSettings.api.endpoints.default
          const token = localStorage.getItem('authorization')
          instance.defaults.headers.common.Authorization = `Bearer ${token}`
          const result = await instance.get(
            `api/double-prevention-management/hidden-danger-rectification-checklists/${row.id}`
          )
          if (result.status === 200 && result.data) {
            resVal = result.data
          }
        } else {
          const [err, res] = await hiddenDangerRectificationChecklistApi.get(row.id)
          if (!err) {
            resVal = res
          }
        }
        if (row.workflowTaskId) {
          resVal.workflowTaskId = row.workflowTaskId
        }
        if (row.currentWorkflowTaskId) {
          resVal.currentWorkflowTaskId = row.currentWorkflowTaskId
        }
        if (row.currentWorkflowDelayTaskId) {
          resVal.currentWorkflowDelayTaskId = row.currentWorkflowDelayTaskId
        }
        this.FormData = resVal
      }
      this.formDialog = true
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
</style>
